// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3wB3F","label":"Radio_label__1crDT","checkMark":"Radio_checkMark__1f1wC","disabled":"Radio_disabled__2JOrE"};